'use strict';
import isNil from 'lodash/isNil';
import Api from '@/api/user.js';
import axios from 'axios';

const state = {
  error: null,
  loading: false,
  company: null,
  logo_file: null
};

const actions = {
  fetch({ commit, dispatch }) {
    commit('fetch');

    return Api.fetchOneCompany()
      .then(data => {
        if (Object.keys(data.meta).length !== 0 && data.meta.constructor === Object) {
          if (data.meta.active_process !== undefined) {
            dispatch('process/setName', data.meta.active_process, { root: true });
          }
        }

        commit('fetchSuccess', data);
      })
      .catch(err => commit('fetchFailure', err));
  },

  save({ commit }, params) {
    const model = params.model;
    if (!model.id) {
      throw new Error('Company empty id');
    }

    const logoBlob = params.logoBlob ? params.logoBlob : null;
    let modelPrepared = Object.assign(
      {},
      {
        id: model.id ? parseInt(model.id) : null,
        name: model.name ? model.name : null,
        geo: model.geo ? model.geo : null,
        city: model.city ? model.city : null,
        country: model.country ? model.country : null,
        language: model.language ? model.language : null,
        time_format: model.time_format ? model.time_format : 24
      }
    );
    if (!isNil(model.is_password_expiry)) {
      modelPrepared = Object.assign(modelPrepared, {
        is_password_expiry: model.is_password_expiry
      });
    }
    if (!isNil(model.is_unique_password)) {
      modelPrepared = Object.assign(modelPrepared, {
        is_unique_password: model.is_unique_password
      });
    }
    commit('save');

    return Api.updateOneCompany(modelPrepared)
      .then(data => {
        if (logoBlob) {
          return Api.saveOneCompanyLogo(modelPrepared.id, logoBlob);
        }

        return data;
      })
      .then(data => {
        commit('saveSuccess', data);
        this._vm.$noty.success(window.$tr('settings.company.modals.saveSuccess.text'));
      })
      .catch(() => {
        this._vm.$noty.error(window.$tr('settings.company.modals.saveFailure.text'));
        // throw new Error(err);
      });
  },

  upadte_company_logo({ commit }, model) {
    let { id, logoBlob } = model;
    let data = new FormData();
    data.append('logo', logoBlob);

    return axios
      .post(`1.0/user-companies/${id}/logo`, data)
      .then(response => {
        commit('saveSuccess', response.data.data[0]);
        this._vm.$noty.success(window.$tr('settings.company.modals.saveSuccess.text'));
        return response;
      })
      .catch(err => {
        commit('fetchFailure', err);
        this._vm.$noty.error(window.$tr('settings.company.modals.saveFailure.text'));
        // throw new Error(err);
      });
  }
};

const mutations = {
  fetch(state) {
    state.loading = true;
  },

  fetchSuccess(state, data) {
    state.loading = false;
    state.company = data;
  },

  fetchFailure(state, err) {
    state.loading = false;
    state.error = err;
  },

  update(state, { model, data }) {
    Object.assign(model, data);
  },

  save(state) {
    state.loading = true;
  },

  saveSuccess(state, data) {
    state.company = data;
    state.loading = false;
  },

  saveFailure(state, err) {
    state.loading = false;
    state.error = err;
  },

  set_logo_file(state, fileList) {
    state.logo_file = fileList;
  }
};

const getters = {
  error(state) {
    return state.error;
  },

  loading(state) {
    return state.loading;
  },

  one(state) {
    return state.company || { name: null, logo: null };
  },

  logo_file() {
    return state.logo_file;
  },

  process() {
    return state.company && state.company.meta && state.company.meta.active_process
      ? state.company.meta.active_process
      : null;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
